export { default } from './LocalClock';
